(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scrolling-ticker"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("cc-scrolling-ticker")) {
  customElements.define(
    "cc-scrolling-ticker",
    class extends HTMLElement {
      connectedCallback() {
        this.original = this.querySelector("[data-original]");
        this.track = this.querySelector(".cc-ticker__track");
        this.media = matchMedia("(prefers-reduced-motion: reduce)");
        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.build());
        };
        this.select = () => this.setAttribute("data-editor-selected", "");
        this.deselect = () => this.removeAttribute("data-editor-selected");
        this.addEventListener("shopify:block:select", this.select);
        this.addEventListener("shopify:block:deselect", this.deselect);
        this.media.addEventListener("change", this.refresh);
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this);
        [...this.original.children].forEach((item) =>
          this.observer.observe(item),
        );
        document.fonts.ready.then(() => {
          if (this.isConnected) this.refresh();
        });
        this.refresh();
      }
      clone(element) {
        const copy = element.cloneNode(true);
        copy.removeAttribute("data-original");
        copy.setAttribute("data-clone", "");
        copy.setAttribute("aria-hidden", "true");
        [copy, ...copy.querySelectorAll("*")].forEach((node) => {
          node.removeAttribute("id");
          node.removeAttribute("data-shopify-editor-block");
          if (node.matches("a, button, input, select, textarea, [tabindex]"))
            node.setAttribute("tabindex", "-1");
        });
        return copy;
      }
      build() {
        this.removeAttribute("data-ready");
        this.querySelectorAll("[data-clone]").forEach((copy) => copy.remove());
        if (this.media.matches) return;
        const width = this.original.getBoundingClientRect().width;
        if (!width || !this.clientWidth) return;
        const items = [...this.original.children];
        const repetitions = Math.ceil(this.clientWidth / width);
        for (let i = 1; i < repetitions; i++)
          items.forEach((item) => this.original.append(this.clone(item)));
        const distance = this.original.getBoundingClientRect().width;
        this.track.append(this.clone(this.original));
        const speed = Math.max(10, Number(this.dataset.speed) || 60);
        this.style.setProperty("--cc-duration", `${distance / speed}s`);
        this.setAttribute("data-ready", "");
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.media?.removeEventListener("change", this.refresh);
        this.removeEventListener("shopify:block:select", this.select);
        this.removeEventListener("shopify:block:deselect", this.deselect);
        this.querySelectorAll("[data-clone]").forEach((copy) => copy.remove());
        this.removeAttribute("data-ready");
      }
    },
  );
}

  } catch(e) { console.error(e); }
})();
})();
